import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, filter, Subscription } from 'rxjs';
import {
  Microsoft365UserLicenses,
  MicrosoftTeamsAudioConferencing,
  SelectFieldConfig,
} from '../../../shared/models/generated/ziroModels';
import { Microsoft360ViewContext } from '../../../shared/contexts/microsoft-360-view.context';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { MicrosoftTeamsAudioConferencingFieldConfigResource } from '../../shared/resources/microsoft-teams-audio-conferencing-field-config.resource';
import { MicrosoftTenantsStateContext } from '../../../shared/contexts/microsoft-tenants-state.context';

@Component({
  selector: 'ziro-teams-audio-conferencing',
  templateUrl: './teams-audio-conferencing.component.html',
  standalone: false,
})
export class TeamsAudioConferencingComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private microsoft360ViewContext = inject(Microsoft360ViewContext);
  private microsoftTeamsAudioConferencingFieldConfigResource = inject(
    MicrosoftTeamsAudioConferencingFieldConfigResource,
  );
  private _tenantsStateContext = inject(MicrosoftTenantsStateContext);

  ziroIcons = ZiroIcons;
  isLoading = true;
  pageDisabled = true;
  ms365UserLicenses: Microsoft365UserLicenses;
  fieldConfig: SelectFieldConfig<string>;
  upn = '';
  tenantId: number;
  msTeamsAudioConferencing: MicrosoftTeamsAudioConferencing;

  private _subscriptions = new Subscription();

  ngOnInit(): void {
    this._initContexts();
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  private _initContexts(): void {
    this.upn = this.route.snapshot.paramMap.get('upn');

    const ms360ViewSub = combineLatest([
      this.microsoft360ViewContext.state$,
      this._tenantsStateContext.cachedTenantState$.pipe(filter((cachedTenant) => !!cachedTenant?.tenantId)),
    ]).subscribe(([ms360View, cachedTenant]) => {
      if (ms360View.microsoft365UserLicenses) {
        this.upn = ms360View.microsoft365UserLicenses.userPrincipalName;
        this.pageDisabled = false;
        this.ms365UserLicenses = ms360View.microsoft365UserLicenses;
        this.msTeamsAudioConferencing = ms360View.teamsAudioConferencing;
        this.tenantId = cachedTenant.tenantId;

        if (this.msTeamsAudioConferencing) {
          this.microsoftTeamsAudioConferencingFieldConfigResource
            .getByTenantId(this.tenantId)
            .subscribe((audioConferencingFieldConfig) => {
              this.fieldConfig = audioConferencingFieldConfig.audioConferencingServiceNumbers;
              this.isLoading = false;
            });
        } else {
          window.location.href = `${window.location.origin}/app2/#/helpdesk/tenants/${this.tenantId}/360-view/${this.upn}`;
        }
      }
    });
    this._subscriptions.add(ms360ViewSub);
  }
}
